import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import homeIcon from '../assets/home.svg';
import publiIcon from '../assets/iconpubli.svg';
import userIcon from '../assets/iconuser.svg';
import reviewsIcon from '../assets/review/reviewsIcon.svg';
import logoutIcon from '../assets/iconlogout.svg';
import settingIcon from '../assets/setting.svg';
import categoriesIcon from '../assets/categories/categories.svg';
import Logout from '../logout/Logout';
import { redirectToMyPrevisite } from '../service/authService';
import { useGlobalUnreadCount } from '../reviews/hooks/useGlobalUnreadCount';

function Navbar() {
    const location = useLocation();
    const path = location.pathname;
    const unselectedColor = 'brightness(50%) grayscale(100%)';
    const selectedColor = 'var(--primary-color)';
    const isAdmin = useSelector((state: RootState) => state.user.isAdmin);
    const isSsoUser = useSelector((state: RootState) => state.user.isSsoUser);
    const userId = useSelector((state: RootState) => state.user.userMyId);
    const groupement = useSelector((state: RootState) => state.user.groupement);
    const isNetworkAdmin = !isAdmin && !isSsoUser && groupement?.id !== 1;

    const handleRedirect = () => {
        redirectToMyPrevisite(userId);
    };

    const countUnreadReview = useGlobalUnreadCount(userId, isSsoUser);

    return (
        <div className="flex items-center bg-white flex-col h-full justify-start gap-10">
            <div className="w-full pt-12 flex flex-col items-start justify-start flex-none gap-10">
                <div className="flex items-center flex-none gap-3 relative w-[250px] px-[30px]">
                    <img
                        src={homeIcon}
                        alt="icon home"
                        style={{
                            filter:
                                path === '/dashboard' || path === '/dashboard_admin'
                                    ? ''
                                    : unselectedColor,
                        }}
                    />
                    {isSsoUser ? (
                        <Link
                            to={'/dashboard_agency'}
                            className="flex-1 font-montserrat medium font-semibold not-italic tracking-[0px] leading-[120%] relative no-underline "
                            style={{
                                color:
                                    path === '/dashboard' || path === '/dashboard_admin'
                                        ? selectedColor
                                        : 'dark-gray',
                            }}
                        >
                            Accueil
                        </Link>
                    ) : (
                        <Link
                            to={isNetworkAdmin ? '/dashboard_admin' : '/dashboard'}
                            className="flex-1 font-montserrat medium font-semibold not-italic tracking-[0px] leading-[120%] relative no-underline "
                            style={{
                                color:
                                    path === '/dashboard' || path === '/dashboard_admin'
                                        ? selectedColor
                                        : 'dark-gray',
                            }}
                        >
                            Accueil
                        </Link>
                    )}
                </div>
                <div className="flex items-center flex-none gap-3 relative w-[250px] px-[30px]">
                    <img
                        src={publiIcon}
                        alt="icon publications"
                        style={{
                            filter:
                                path === '/publications' ||
                                path === '/archived_publications' ||
                                path === '/add_publication'
                                    ? ''
                                    : unselectedColor,
                        }}
                    />
                    <Link
                        to={'/publications'}
                        className="flex-1 font-montserrat medium font-semibold not-italic tracking-[0px] leading-[120%] relative no-underline "
                        style={{
                            color:
                                path === '/publications' ||
                                path === '/archived_publications' ||
                                path === '/add_publication'
                                    ? selectedColor
                                    : '',
                        }}
                    >
                        Mes publications
                    </Link>
                </div>
                {isAdmin && (
                    <div className="flex items-center flex-none gap-3 relative w-[250px] px-[30px]">
                        <img
                            src={categoriesIcon}
                            alt="icon biblothèque de contenus"
                            style={{
                                filter:
                                    path === '/categories' || path === '/archived_categories'
                                        ? ''
                                        : unselectedColor,
                            }}
                        />
                        <Link
                            to={'/categories'}
                            className="flex-1 font-montserrat medium font-semibold not-italic tracking-[0px] leading-[120%] relative no-underline "
                            style={{
                                color:
                                    path === '/categories' || path === '/archived_categories'
                                        ? selectedColor
                                        : '',
                            }}
                        >
                            Bibliothèque de contenus
                        </Link>
                    </div>
                )}
                {isSsoUser && (
                    <div className="flex items-center justify-between flex-none gap-3 relative w-[250px] px-[30px]">
                        <img
                            className="w-6 -ml-0.5"
                            src={reviewsIcon}
                            alt="icon reviews"
                            style={{
                                filter: path === '/reviews' ? '' : unselectedColor,
                            }}
                        />
                        <Link
                            to={'/reviews'}
                            className="flex-1 font-montserrat medium font-semibold not-italic tracking-[0px] leading-[120%] relative no-underline "
                            style={{
                                color: path === '/reviews' ? selectedColor : '',
                            }}
                        >
                            Mes avis
                        </Link>
                        {countUnreadReview > 0 && (
                            <span className="medium font-bold uppercase leading-[120%] text-primary bg-primary-light flex items-center justify-center flex-col gap-[10px] px-2 py-1 rounded-full">
                                {countUnreadReview}
                            </span>
                        )}
                    </div>
                )}
                {!isSsoUser && (
                    <div className="flex items-center flex-none gap-3 relative w-[250px] px-[30px]">
                        <img
                            src={userIcon}
                            alt="icon user"
                            style={{
                                filter: path === '/users' ? '' : unselectedColor,
                            }}
                        />
                        <Link
                            to={'/users'}
                            className="flex-1 font-montserrat medium font-semibold not-italic tracking-[0px] leading-[120%] relative no-underline "
                            style={{
                                color: path === '/users' ? selectedColor : '',
                            }}
                        >
                            Utilisateurs
                        </Link>
                    </div>
                )}
            </div>
            {isAdmin && (
                <div className="flex items-center flex-none gap-3 relative w-[250px] px-[30px]">
                    <img
                        src={settingIcon}
                        className={'icon-setting'}
                        alt="icon setting"
                        style={{
                            filter: path === '/admin' ? '' : unselectedColor,
                        }}
                    />
                    <Link
                        to={'/administration'}
                        className={
                            'flex-1 font-montserrat medium font-semibold not-italic tracking-[0px] leading-[120%] relative no-underline'
                        }
                        style={{
                            color: path === '/admin' ? selectedColor : '',
                        }}
                    >
                        Administration
                    </Link>
                </div>
            )}
            {!isSsoUser ? (
                <div className="flex py-10 w-full">
                    <div className="flex items-center flex-none gap-3 relative w-[250px] px-[30px]">
                        <img src={logoutIcon} alt="icon logout" />
                        <Logout />
                    </div>
                </div>
            ) : (
                <div className="flex py-10 w-full">
                    <div className="flex items-center flex-none gap-3 relative w-[250px] px-[30px]">
                        <button
                            onClick={handleRedirect}
                            className={
                                'bg-none flex items-center flex-1 font-montserrat medium font-semibold not-italic tracking-[0px] leading-[120%] relative no-underline '
                            }
                        >
                            <img src={logoutIcon} alt="icon logout" />
                            <span className={'text-medium text-left ml-[10px]'}>
                                Retour sur my.previsite
                            </span>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Navbar;
